var _defs, _rect, _rect2, _line, _line2, _line3, _line4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWnLogoGoldGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 395.18,
    height: 121.07,
    viewBox: "0 0 395.18 121.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#ffc629;}.cls-1,.cls-3{stroke-miterlimit:10;}.cls-1{stroke-width:1.08px;}.cls-2{stroke-miterlimit:10;stroke-width:1.08px;}.cls-3{stroke-width:1.18px;}.cls-4{fill:#414042;}.cls-5{fill:#ffc629;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.32,
    y: 28.39,
    width: 64.3,
    height: 64.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 228.85,
    y: 274.04,
    width: 64.3,
    height: 64.3,
    transform: "translate(-339.6 28.59) rotate(-45)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 61.48,
    y1: 16.63,
    x2: 61.48,
    y2: 103.44
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.79,
    y1: 29.34,
    x2: 92.17,
    y2: 90.73
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.07,
    y1: 60.03,
    x2: 104.89,
    y2: 60.03
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.79,
    y1: 90.73,
    x2: 92.17,
    y2: 29.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365.27,316.11h-3.91L359,302.31l-2.5,13.8h-3.87l-4.15-23.44h4.33l2.11,15.49,2.6-15.49h3.38l2.39,15.49,2.25-15.49h4Z",
    transform: "translate(-199.53 -245.65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386,316.11l-.77-4.61h-4.15l-.84,4.61H376.2l4.72-23.44h4.89l4.68,23.44ZM383.29,299l-1.58,9.05h3Z",
    transform: "translate(-199.53 -245.65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.28,316.11,405,306.46l-1.51,3.1v6.55h-4.37V292.67h4.37v10.74l4.72-10.74h4.4L408,302.56l4.82,13.55Z",
    transform: "translate(-199.53 -245.65)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M421.66,316.11V292.67h11.19v3.77H426v5.81h4.72v3.45H426v6.51h6.83v3.91H421.66Z",
    transform: "translate(-199.53 -245.65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M452.42,316.11l-4.54-10-1.66-3.73v13.73h-4V292.67H446l4.33,10.17,1.55,3.73v-13.9h3.94v23.44Z",
    transform: "translate(-199.53 -245.65)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M465.87,316.11V292.67h11.19v3.77h-6.83v5.81H475v3.45h-4.72v6.51h6.83v3.91H465.87Z",
    transform: "translate(-199.53 -245.65)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M494,296.54v19.57h-4.4V296.54H485.3v-3.87h13v3.87Z",
    transform: "translate(-199.53 -245.65)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M522.72,316.11h-3.91l-2.36-13.8-2.5,13.8h-3.87l-4.15-23.44h4.33l2.11,15.49L515,292.67h3.38l2.39,15.49L523,292.67h4Z",
    transform: "translate(-199.53 -245.65)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M542,316.64c-4.08,0-6.65-2.68-6.65-6.41V298.54c0-3.7,2.57-6.37,6.65-6.37s6.65,2.68,6.65,6.37v11.69C548.7,314,546.16,316.64,542,316.64Zm2.25-18.38a2.24,2.24,0,1,0-4.47,0v12.25a2.24,2.24,0,1,0,4.47,0Z",
    transform: "translate(-199.53 -245.65)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M569.36,316.25c-1.72,0-2.39-1.41-2.39-3.45v-4.4a1.78,1.78,0,0,0-1.79-2h-2.29v9.72h-4.37V292.67h7.22c3.2,0,5.35,1.83,5.35,5.1v3.31a3.49,3.49,0,0,1-2.64,3.63,3.59,3.59,0,0,1,2.71,3.56v4.29A3.27,3.27,0,0,0,572,315v1.3ZM566.82,298c0-1.06-.46-1.69-1.55-1.69h-2.39v6.9h2.22c1.13,0,1.72-.6,1.72-1.87V298Z",
    transform: "translate(-199.53 -245.65)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M590.13,316.11l-3.24-9.65-1.51,3.1v6.55H581V292.67h4.37v10.74l4.72-10.74h4.4l-4.61,9.89,4.82,13.55Z",
    transform: "translate(-199.53 -245.65)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.42,289.07c-10-1.48-13.19,4.27-13.41,4.68-.22-.41-3.46-6.16-13.41-4.68-11.1,1.65-14,16.2-4.83,27.76,9.92,12.43,17.72,15.57,18.22,15.77h0c.5-.19,8.3-3.34,18.22-15.77,9.25-11.56,6.29-26.11-4.81-27.76",
    transform: "translate(-199.53 -245.65)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261,319.71c-3,0-8.45-.87-10.88-3.56-1.59-1.76-2.9-4.47,3-3a4.84,4.84,0,0,1,.19-1.33,90,90,0,0,0-1.08-12.32c0-.23.11-.36.64-.42a72.95,72.95,0,0,1,16.18,0c.53,0,.68.19.64.42a88.42,88.42,0,0,0-1.08,12.32,4.79,4.79,0,0,1,.19,1.33c5.94-1.49,4.63,1.22,3,3-2.43,2.69-7.85,3.56-10.88,3.56",
    transform: "translate(-199.53 -245.65)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.35,311.85a32.69,32.69,0,0,0,15.32,0s.18,0,.18.45v2.24s-2.14,1.29-7.84,1.29-7.84-1.32-7.84-1.32v-2.28s0-.35.18-.38",
    transform: "translate(-199.53 -245.65)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.72,245.77c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.61-5.78,3.13-13-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261,261.09c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.22,1.35-3.93,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.18,257.16a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23v1.12a8.37,8.37,0,0,1-3.92.64,8.16,8.16,0,0,1-3.92-.66v-1.14s0-.17.09-.19",
    transform: "translate(-199.53 -245.65)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.72,345c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.61-5.78,3.13-13.06-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261,360.28c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.22,1.35-3.93,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.18,356.35a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23v1.12a8.37,8.37,0,0,1-3.92.64,8.16,8.16,0,0,1-3.92-.66v-1.14s0-.18.09-.19",
    transform: "translate(-199.53 -245.65)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.64,330.44c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.62-5.78,3.14-13.06-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.94,345.75c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.22,1.35-3.93,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.11,341.82a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23v1.12a8.37,8.37,0,0,1-3.92.64,8.16,8.16,0,0,1-3.92-.66V342s0-.17.09-.19",
    transform: "translate(-199.53 -245.65)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302.78,330.44c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.61-5.78,3.14-13.06-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.07,345.75c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.21,1.35-3.92,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.24,341.82a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23v1.12a8.37,8.37,0,0,1-3.92.64,8.16,8.16,0,0,1-3.92-.66V342s0-.17.09-.19",
    transform: "translate(-199.53 -245.65)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.64,260.3c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.62-5.78,3.14-13.06-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.94,275.62c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.22,1.34-3.93,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.11,271.69a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23V273a8.37,8.37,0,0,1-3.92.64A8.16,8.16,0,0,1,222,273v-1.14s0-.18.09-.19",
    transform: "translate(-199.53 -245.65)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.11,295.37c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.62-5.78,3.14-13.06-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.41,310.68c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.22,1.35-3.93,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.58,306.75a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23v1.12a8.37,8.37,0,0,1-3.92.64,8.16,8.16,0,0,1-3.92-.66v-1.14s0-.17.09-.19",
    transform: "translate(-199.53 -245.65)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.3,295.37c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.62-5.78,3.14-13.06-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M310.6,310.68c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.22,1.35-3.93,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.77,306.75a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23v1.12a8.37,8.37,0,0,1-3.92.64,8.16,8.16,0,0,1-3.92-.66v-1.14s0-.17.09-.19",
    transform: "translate(-199.53 -245.65)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302.78,260.3c-5-.74-6.6,2.13-6.71,2.34-.11-.21-1.73-3.08-6.71-2.34-5.55.82-7,8.1-2.41,13.88,5,6.21,8.86,7.79,9.11,7.88h0c.25-.1,4.15-1.67,9.11-7.88,4.61-5.78,3.14-13.06-2.41-13.88",
    transform: "translate(-199.53 -245.65)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.07,275.62c-1.51,0-4.22-.43-5.44-1.78-.8-.88-1.45-2.24,1.52-1.49,0,0,0-.62.1-.66a45.12,45.12,0,0,0-.54-6.16c0-.11.06-.18.32-.21a37.2,37.2,0,0,1,8.08,0c.26,0,.34.09.32.21a44.85,44.85,0,0,0-.54,6.16,2.41,2.41,0,0,1,.1.66c3-.75,2.32.61,1.52,1.49-1.21,1.34-3.92,1.78-5.44,1.78",
    transform: "translate(-199.53 -245.65)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.24,271.69a16.52,16.52,0,0,0,7.66,0s.09,0,.09.23V273a8.37,8.37,0,0,1-3.92.64,8.16,8.16,0,0,1-3.92-.66v-1.14s0-.18.09-.19",
    transform: "translate(-199.53 -245.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWnLogoGoldGray);
export default __webpack_public_path__ + "static/media/wn-logo-gold-gray.a482302b48bc51ebf131d9038e4fefcb.svg";
export { ForwardRef as ReactComponent };